// ==============================|| THEME CONSTANT ||============================== //

// import 'assets/fonts/ALS_Sirius_Bold_0.95.otf'
import 'assets/fonts/Montserrat-Regular.ttf';
import 'assets/fonts/CormorantGaramond-Regular.ttf'

export const APP_DEFAULT_PATH = '/main';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

// Запись по внешним направлениям (раздел "Внешние направления" в /makeAppointment/direction,
// добавление/редактирование внешнего направления). Временно отключена - вернуть true, чтобы включить.
export const EXTERNAL_DIRECTIONS_ENABLED = false;


const config = {
  fontFamily: `'Montserrat'`
};

export default config;
